import { APP_LANGUAGES } from 'ngx-mat-esign360';

const LANGUAGE_CODES = ['en', 'cs', 'sk', 'uk', 'fr'];
export const LANGUAGE_STORAGE_KEY = 'lang-ss';
export const DEFAULT_LANGUAGE_CODE = 'en';

export const SUPPORTED_LANGUAGES = APP_LANGUAGES.filter((supportedLanguage) =>
  LANGUAGE_CODES.includes(supportedLanguage.countryCode)
);
